module.exports = __webpack_public_path__ + "static/featuredBlockLayout2Front-605914e329e7f2cf3cd225692a024c35.png";